import { useCallback, useEffect } from "react";
import wkx from "wkx";
import * as L from "leaflet";
import { GeoJsonObject } from "geojson";

import { useRegularGrid } from "src/hooks";

interface Props {
  map: L.Map;
  caseId: string | number;
  opacity: number;
  pane: string;
}

export function RegularGridOnMap(props: Props) {
  const { map } = props;
  const { data: regularGrid } = useRegularGrid(props.caseId);
  const featureGroup = L.featureGroup();

  /**
   * Callbacks
   */
  const renderRegularGridCallback = useCallback(renderRegularGrid, [
    featureGroup,
    props.opacity,
    props.pane,
    regularGrid,
  ]);

  /**
   * Effects
   */
  useEffect(addFeatureGroupToMap, [featureGroup, map]);
  useEffect(renderRegularGridCallback, [regularGrid, renderRegularGridCallback]);

  /**
   * Functions
   */
  function renderRegularGrid() {
    if (!regularGrid) return;

    const geometry = wkx.Geometry.parse(regularGrid.polygon_frontendSrid).toGeoJSON() as GeoJsonObject;

    const geojsonLayer = L.geoJSON(geometry, {
      pane: props.pane,
      pmIgnore: true,

      style: {
        // @ts-ignore
        opacity: props.opacity,
        fillOpacity: 0.2 * (props.opacity !== undefined ? props.opacity : 1),
        interactive: false,
      },
    });

    featureGroup.addLayer(geojsonLayer);
  }

  function addFeatureGroupToMap() {
    featureGroup.addTo(map);
    return function cleanup() {
      featureGroup.removeFrom(map);
    };
  }

  // return nothing because Leaflet.js does the rendering
  return null;
}
